import React from 'react';
import ReactDOM from 'react-dom/client';
import '@givebutter/primitives/dist/index.css';
import { getSentryEnv } from '@givebutter/util';
import * as Sentry from '@sentry/browser';
import App from 'App';
import Axios from 'axios';
import 'index.css';

Sentry.init({
  beforeSend: (event, hint) => {
    const originalError = hint.originalException;

    if (Axios.isAxiosError(originalError)) {
      event.contexts = {
        ...event.contexts,
        axiosRequest: originalError.request,
        axiosResponse: originalError.response as Sentry.Event['contexts'],
      };
    }

    return event;
  },
  dsn: import.meta.env.VITE_LIVEDISPLAY_SENTRY_DSN,
  environment: getSentryEnv(),
  profilesSampleRate: 0.2,
  replaysOnErrorSampleRate: 0.2,
  replaysSessionSampleRate: 0.1,
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/givebutter\.com\/api/,
    /^https:\/\/givebutter\.test\/api/,
    /^https:\/\/legendairy\.xyz\/api/,
  ],
  tracesSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
